import { render, staticRenderFns } from "./FormTutoratcreate.vue?vue&type=template&id=15bb334a&"
import script from "./FormTutoratcreate.vue?vue&type=script&lang=js&"
export * from "./FormTutoratcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports